import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';

import userReducer from './slices/user';
import transactionReducer from './slices/transaction';

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: []
};

const rootReducer = combineReducers({
  user: userReducer,
  transaction: transactionReducer
});

export { rootPersistConfig, rootReducer };